import { render, staticRenderFns } from "./ReviewCard.vue?vue&type=template&id=66cd32cc&scoped=true&"
import script from "./ReviewCard.vue?vue&type=script&lang=js&"
export * from "./ReviewCard.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCard.vue?vue&type=style&index=0&id=66cd32cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66cd32cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VRow,VSpacer})
